import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import cn from 'classnames';
import { cloneElement, Fragment, isValidElement, } from 'react';
import { isForwardRef, isValidElementType } from 'react-is';
import { isBrowser } from '@snack-uikit/utils';
import { TRIGGER } from './constants';
export function getArrowPositionStyles({ placement, x, y, ref }) {
    if (!ref.current) {
        return {};
    }
    const width = ref.current.offsetWidth;
    switch (true) {
        case placement.startsWith('top'):
            return {
                left: x,
                bottom: -width,
                transform: 'rotate(-90deg)',
            };
        case placement.startsWith('bottom'):
            return {
                left: x,
                top: -width,
                transform: 'rotate(90deg)',
            };
        case placement.startsWith('left'):
            return {
                top: y,
                right: -(width - 1),
                transform: 'rotate(180deg)',
            };
        case placement.startsWith('right'):
        default:
            return {
                top: y,
                left: -(width - 1),
            };
    }
}
export const getPopoverRootElement = () => (isBrowser() ? document.body : undefined);
export const getArrowOffset = (arrowElement) => (arrowElement === null || arrowElement === void 0 ? void 0 : arrowElement.offsetWidth) || 0;
export const getPopoverTriggerJSX = ({ children, getReferenceProps, setReference, validElementWrapperClassName, disableSpanWrapper, }) => {
    if (isValidElement(children)) {
        if (isForwardRef(children) || isValidElementType(children) || disableSpanWrapper) {
            return cloneElement(children, Object.assign(Object.assign({}, getReferenceProps(Object.assign(Object.assign({}, children.props), { className: cn(children.props.className, validElementWrapperClassName) }))), { 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ref: setReference, key: 'cloned-element' }));
        }
        return (_createElement("span", Object.assign({ className: validElementWrapperClassName, ref: setReference }, getReferenceProps(), { key: 'wrapped-element' }), children));
    }
    if (typeof children === 'function') {
        return _jsx(Fragment, { children: children({ getReferenceProps, ref: setReference }) }, 'function-element');
    }
    return (_createElement("span", Object.assign({ className: validElementWrapperClassName, ref: setReference }, getReferenceProps(), { key: 'wrapped-element' }), children));
};
export const getTriggerProps = (trigger) => {
    const defaultProps = {
        useHoverTrigger: false,
        useClickTrigger: false,
        useFocusTrigger: false,
        keyboardOnly: true,
    };
    switch (trigger) {
        case TRIGGER.Hover:
            return Object.assign(Object.assign({}, defaultProps), { useHoverTrigger: true });
        case TRIGGER.Click:
            return Object.assign(Object.assign({}, defaultProps), { useClickTrigger: true });
        case TRIGGER.FocusVisible:
            return Object.assign(Object.assign({}, defaultProps), { useFocusTrigger: true });
        case TRIGGER.Focus:
            return Object.assign(Object.assign({}, defaultProps), { useFocusTrigger: true, keyboardOnly: false });
        case TRIGGER.ClickAndFocusVisible:
            return Object.assign(Object.assign({}, defaultProps), { useFocusTrigger: true, useClickTrigger: true });
        case TRIGGER.HoverAndFocusVisible:
            return Object.assign(Object.assign({}, defaultProps), { useFocusTrigger: true, useHoverTrigger: true });
        case TRIGGER.HoverAndFocus:
            return Object.assign(Object.assign({}, defaultProps), { useFocusTrigger: true, useHoverTrigger: true, keyboardOnly: false });
        default:
            return defaultProps;
    }
};
export const stopPropagationMouse = (e) => e.stopPropagation();
export const stopPropagationTouch = (e) => e.stopPropagation();
export function referenceActionToEvent(value) {
    if (value.slice(0, 2) === 'on') {
        return value.replace('on', '').toLowerCase();
    }
    return value.toLowerCase();
}
function createSyntheticEvent(nativeEvent) {
    return Object.assign(Object.assign({}, nativeEvent), { nativeEvent });
}
export function mapPopoverActionsToSynthetic(actions) {
    const syntheticActions = {};
    Object.entries(actions).forEach(([key, value]) => {
        syntheticActions[key] = (e) => {
            value(createSyntheticEvent(e));
        };
    });
    return syntheticActions;
}
